import React from "react";
import Seo from "../seo/Seo";
import { Section, Heading, PageHero, CTASection, Bullets, GoldButton } from "../components/ui-kit";
import { IMAGES } from "../mock/mock";

const breadcrumbs = [{ name: "Home", path: "/" }, { name: "Custom Homes", path: "/custom-homes" }];

const CustomHomes = () => (
  <>
    <Seo
      title="Custom Homes & Custom Home Construction | Build Highland Homes"
      description="Learn how Build Highland Homes designs and builds custom homes in Central Florida. Full design flexibility, premium materials, and build-on-your-lot custom home construction."
      path="/custom-homes"
      keywords="custom homes, custom home construction, custom home building, build a custom home, custom home contractor"
      breadcrumbs={breadcrumbs}
    />
    <PageHero overline="Custom Home Builder" title="Custom Homes Built Around You" subtitle="A custom home from Build Highland Homes is designed for your lifestyle and your property — not chosen from a fixed catalog. Every home is built on your lot in Central Florida." image={IMAGES.newHomeBuild} />

    <Section className="bg-[#0b0b0b]">
      <div className="grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <Heading center={false} overline="What Is a Custom Home?" title="True Custom Home Construction" subtitle="A custom home is designed and built specifically for you. You have flexibility over the floor plan, architectural style, materials, and finishes — all shaped by your lifestyle and the realities of your specific lot." />
          <Bullets items={[
            "Full design flexibility — layout, style, and finishes",
            "Site-specific planning around your lot's characteristics",
            "One-story and two-story custom homes",
            "Premium materials and quality craftsmanship",
            "Clear communication and quality control at every stage",
          ]} />
        </div>
        <img src={IMAGES.realHomeConstruction} alt="Custom home under construction in Central Florida" className="w-full h-[420px] object-cover border border-[#c9a24b]/20" loading="lazy" />
      </div>
    </Section>

    <Section className="bg-[#0f0f0f]">
      <Heading overline="Our Approach" title="How We Build Custom Homes" />
      <div className="grid md:grid-cols-3 gap-6">
        {[
          { t: "Design Flexibility", d: "From architectural style to floor-plan layout, your home is shaped around how you actually live." },
          { t: "Site Considerations", d: "We plan around your lot's orientation, access, drainage, and setbacks for a home that fits its site." },
          { t: "Materials & Finishes", d: "Choose the materials, fixtures, and finishes that match your taste and your budget." },
          { t: "Construction Process", d: "A structured build with regular, honest communication so you always know where things stand." },
          { t: "Quality Control", d: "Inspections and attention to detail at every milestone of construction." },
          { t: "Personalization", d: "The details that make the home unmistakably yours, from layout to the final touches." },
        ].map((c) => (
          <div key={c.t} className="bg-[#141414] border border-[#c9a24b]/15 p-7">
            <h3 className="font-serif-display text-xl text-[#e3c77a] mb-3">{c.t}</h3>
            <p className="text-[#a39d90] text-sm leading-relaxed">{c.d}</p>
          </div>
        ))}
      </div>
      <div className="flex flex-wrap justify-center gap-4 mt-12">
        <GoldButton to="/custom-home-design" variant="outline">Custom Home Design</GoldButton>
        <GoldButton to="/build-on-your-lot" variant="outline">Build on Your Lot</GoldButton>
        <GoldButton to="/our-process" variant="outline">Our Process</GoldButton>
      </div>
    </Section>

    <CTASection />
  </>
);

export default CustomHomes;
